import { render } from "./ColumnOffset.vue?vue&type=template&id=2ac50c1c&scoped=true"
import script from "./ColumnOffset.vue?vue&type=script&lang=js"
export * from "./ColumnOffset.vue?vue&type=script&lang=js"

import "./ColumnOffset.vue?vue&type=style&index=0&id=2ac50c1c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ac50c1c"

export default script